<app-confirm-dialog
  [(isOpen)]="removeConfirmOpen"
  [title]="
    'tenantConfiguration.advanced.removeConfigConfirm'
      | translate : { key: selectedOption() }
  "
  [primaryText]="'client.removeUserDialogConfirmLabel' | translate"
  [secondaryText]="'client.removeUserDialogCancelLabel' | translate"
  [headerPlacement]="ViewAlign.CENTER"
  [headerGap]="Spacing.SMALL"
  (handlePrimaryButton)="removeConfig()"
  (handleSecondaryButton)="closeConfirmationDialog()"
  [titleAlignment]="TextAlign.CENTER"
></app-confirm-dialog>
<div class="advanced-header-container">
  <header class="advanced-header">
    <h1 class="section-title">{{ 'common.advanced' | translate }}</h1>
  </header>
</div>
<div class="advanced-table-container">
  <app-table
    class="advanced-table"
    [config]="tableConfig"
    [tableData]="tableData()"
    (handleOptionSelected)="onOptionSelected($event)"
    [hideOptionIndex]="hideOptionIndex()"
    [paginate]="false"
  ></app-table>
</div>
<div class="advanced-create-container" [ngClass]="{ editing: editMode() }">
  <app-select-dropdown
    class="advanced-dropdown"
    [options]="configTypes()"
    (handleSelect)="updateNewConfigType($event)"
    [(selected)]="newConfigType"
    [placeholder]="typeInputPlaceholder()"
    height="small"
    [disabled]="editMode()"
  ></app-select-dropdown>
  <app-select-dropdown
    class="advanced-dropdown"
    [options]="currentAvailableKeys()"
    [(selected)]="newConfigKey"
    [placeholder]="keyInputPlaceholder()"
    height="small"
    [disabled]="editMode()"
  ></app-select-dropdown>
  <app-input
    (signalValueChanged)="updateNewConfigValue($event)"
    [inputValue]="newConfigValue"
    width="full"
    [size]="InputSize.MEDIUM"
    variant="outline"
  ></app-input>
  <app-button
    *ngIf="!editMode()"
    (handleClick)="updateConfig()"
    [disabled]="!canAdd()"
    [buttonIcon]="ButtonIcon.PLUS"
    [shape]="ButtonShape.CIRCLE"
    [spacingBottom]="Spacing.NONE"
    [size]="ButtonSize.X_SMALL"
    [type]="ButtonType.SECONDARY"
  ></app-button>
  <div *ngIf="editMode()" class="edit-buttons-container">
    <app-button
      (handleClick)="updateConfig()"
      [disabled]="!canAdd()"
      [buttonIcon]="ButtonIcon.CHECK"
      [shape]="ButtonShape.CIRCLE"
      [spacingBottom]="Spacing.NONE"
      [size]="ButtonSize.X_SMALL"
      [type]="ButtonType.SECONDARY"
    ></app-button>
    <app-button
      (handleClick)="cancelEdit()"
      [buttonIcon]="ButtonIcon.X"
      [shape]="ButtonShape.CIRCLE"
      [spacingBottom]="Spacing.NONE"
      [size]="ButtonSize.X_SMALL"
      [type]="ButtonType.SECONDARY"
    ></app-button>
  </div>
</div>
